var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTotalSessions = function SvgTotalSessions(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4765 34.5001C11.4511 33.8542 8.66139 32.3891 6.41228 30.265C4.16316 28.1409 2.54118 25.4394 1.72359 22.4557C0.905987 19.4721 0.924228 16.3211 1.77631 13.3472C2.6284 10.3732 4.28155 7.69068 6.5551 5.59271C8.82866 3.49474 11.6351 2.06207 14.6679 1.45125C17.7006 0.840433 20.8429 1.07497 23.7513 2.12923C26.6597 3.18349 29.2224 5.01691 31.1594 7.42915C33.0963 9.84138 34.3329 12.7396 34.734 15.8071",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6185 23.625C10.9605 23.625 11.2979 23.547 11.6052 23.397C11.9125 23.247 12.1815 23.029 12.3919 22.7595C12.6023 22.4899 12.7485 22.176 12.8194 21.8415C12.8903 21.507 12.884 21.1607 12.801 20.829L11.676 16.329C11.5543 15.8423 11.2734 15.4103 10.8779 15.1015C10.4825 14.7928 9.99522 14.6251 9.49353 14.625H1.46403C0.843594 17.6728 1.07787 20.8328 2.14096 23.7558C3.20406 26.6788 5.05458 29.2509 7.48803 31.188L9.00003 23.625H10.6185Z",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4775 7.875H25.3815C24.8798 7.87506 24.3925 8.04278 23.9971 8.35152C23.6017 8.66026 23.3207 9.09231 23.199 9.579L22.5 12.3615",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 34.875C30.8456 34.875 34.875 30.8456 34.875 25.875C34.875 20.9044 30.8456 16.875 25.875 16.875C20.9044 16.875 16.875 20.9044 16.875 25.875C16.875 30.8456 20.9044 34.875 25.875 34.875Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.853 25.8751H25.875V21.8971",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTotalSessions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/total-sessions.4d46bcfa.svg";
export { ForwardRef as ReactComponent };